import { infer as Infer, z } from 'zod';

import { groupCreateSchema } from './groupCreate.schema';
import { groupMemberEditSchema } from './groupMemberEdit.schema';

export const groupEditSchema = z.codec(
  groupCreateSchema.in.extend({
    id: z.number(),
    memberChanges: z.array(groupMemberEditSchema).optional(),
  }),
  groupCreateSchema.out.extend({
    id: z.number(),
    memberChanges: z.array(groupMemberEditSchema).optional(),
  }),
  {
    decode: (group) => ({
      ...groupCreateSchema.decode(group),
      id: group.id,
      memberChanges: group.memberChanges,
    }),
    encode: (group) => ({
      ...groupCreateSchema.encode(group),
      id: group.id,
      memberChanges: group.memberChanges,
    }),
  }
);

export type GroupEditSchema = Infer<typeof groupEditSchema.in>;
export type GroupEditSchemaInput = Infer<typeof groupEditSchema.in>;
export type GroupEditSchemaOutput = Infer<typeof groupEditSchema.out>;
